var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Runner } from "../../framework/Runner";
import { setupBingAerialImagery } from "../index";
import { WaitAnimator } from "../../framework/WaitAnimator";
import { AnimationTrack } from "../../framework/AnimationTrack";
import { GlobeCamera } from "../../../impl/controls";
import { Cartographic, Ellipsoid } from "../../../private/math";
import { Vector3 } from "three";
/**
 * 24 hours in seconds
 */
const RUNTIME = 60 * 60 * 24;
/**
 * Generic runner that can be used for viewing tilesets in isolation
 * @param config
 * @param description
 * @param sceneSetup
 * @param overrideCenter
 * @param setupImagery
 */
export function tilesetViewer(config, description, sceneSetup, overrideCenter, setupImagery = true) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML = "<h1>Tileset Viewer</h1>";
        yield Runner.run(config, (renderer, camera) => __awaiter(this, void 0, void 0, function* () {
            // Provide the set of globe layers we would like to use
            if (setupImagery)
                setupBingAerialImagery(renderer);
            const object = yield sceneSetup(renderer, camera);
            renderer.getWorld().addObject(object);
            const center = new Vector3();
            if (overrideCenter === undefined) {
                // Get a position above the estimated center of the tileset. This will select a position that is 100m above
                // the surface of the ellipsoid that is directly above the center of the tileset. This prevents the camera
                // from being placed underground.
                object.getEstimatedCenter(center);
                // Detect when we're getting something near the center of the globe. We can't get good cartographic
                // positions for this case, so we just fall back to null island
                let centerC;
                if (center.length() < 10000) {
                    centerC = new Cartographic();
                }
                else {
                    centerC = Ellipsoid.WGS_84.cartographicForPosition(center);
                }
                centerC.setHeight(500);
                Ellipsoid.WGS_84.cartesianForCartographic(centerC, center);
            }
            else if (Array.isArray(overrideCenter)) {
                center.set(overrideCenter[0], overrideCenter[1], overrideCenter[2]);
            }
            else {
                center.set(overrideCenter.x, overrideCenter.y, overrideCenter.z);
            }
            // Add our camera controls
            const controls = new GlobeCamera(renderer);
            controls.setPositionECEF(center);
            const waitTrack = new AnimationTrack().add(RUNTIME, WaitAnimator.between);
            // Output the tracks, basically we just wait for an ungodly amount of time, so we have plenty of time to
            // interact with the world
            return [waitTrack];
        }));
    });
}
